<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :style="{ fill: filled ? 'currentColor' : 'none' }"
        stroke="currentColor"
        :stroke-width="filled ? 0 : 1.5"
        stroke-linecap="square"
        aria-hidden="true"
        focusable="false"
    >
        <path v-if="name === 'play'" d="M7 4.5 20 12 7 19.5Z" />
        <template v-else-if="name === 'pause'">
            <rect x="6.5" y="4.5" width="4" height="15" />
            <rect x="13.5" y="4.5" width="4" height="15" />
        </template>
        <template v-else-if="name === 'volume'">
            <path d="M4 9h3l4.5-3.5v13L7 15H4z" />
            <path d="M15 9.5a3.6 3.6 0 0 1 0 5" />
            <path d="M17.8 7a7.2 7.2 0 0 1 0 10" />
        </template>
        <template v-else-if="name === 'muted'">
            <path d="M4 9h3l4.5-3.5v13L7 15H4z" />
            <path d="M15.5 9.5l5 5M20.5 9.5l-5 5" />
        </template>
        <template v-else-if="name === 'captions'">
            <rect x="2.8" y="5.5" width="18.4" height="13" />
            <path d="M10 10.6H7.4v2.8H10" />
            <path d="M16.6 10.6H14v2.8h2.6" />
        </template>
        <template v-else-if="name === 'chapters'">
            <path d="M9 6.5h12M9 12h12M9 17.5h12" />
            <path d="M4 6.5h1.6M4 12h1.6M4 17.5h1.6" />
        </template>
        <template v-else-if="name === 'settings'">
            <path d="M3 8.5h10.5M17 8.5h4M3 15.5h4M10.5 15.5h10.5" />
            <rect x="13.5" y="6" width="3.5" height="5" />
            <rect x="7" y="13" width="3.5" height="5" />
        </template>
        <template v-else-if="name === 'pip-enter'">
            <rect x="2.8" y="4.8" width="18.4" height="14.4" />
            <rect x="12" y="11" width="7.5" height="6.5" style="fill: currentColor; stroke: none" />
        </template>
        <template v-else-if="name === 'pip-exit'">
            <rect x="2.8" y="4.8" width="18.4" height="14.4" />
            <rect x="4.5" y="6.5" width="7.5" height="6.5" style="fill: currentColor; stroke: none" />
        </template>
        <path v-else-if="name === 'fullscreen-enter'" d="M4 9.5V4h5.5M20 9.5V4h-5.5M4 14.5V20h5.5M20 14.5V20h-5.5" />
        <path v-else-if="name === 'fullscreen-exit'" d="M9.5 4v5.5H4M14.5 4v5.5H20M9.5 20v-5.5H4M14.5 20v-5.5H20" />
        <template v-else-if="name === 'transcript'">
            <path d="M5 3.5h14v17H5z" />
            <path d="M8.5 8.5h7M8.5 12h7M8.5 15.5h4" />
        </template>
        <template v-else-if="name === 'share'">
            <path d="M12 16.5V4.5" />
            <path d="M7.5 9 12 4.5 16.5 9" />
            <path d="M5 14v6h14v-6" />
        </template>
        <path v-else-if="name === 'close'" d="M6 6l12 12M18 6L6 18" />
        <template v-else-if="name === 'replay'">
            <path d="M4 11.5a8 8 0 1 1 2.6 5.9" />
            <path d="M4 5.5v6h6" />
        </template>
        <path v-else-if="name === 'arrow'" d="M5 12h13M12.5 5.5 19 12l-6.5 6.5" />
        <template v-else-if="name === 'shield'">
            <path d="M12 3.5 19.5 6.5v5c0 4.3-3 7.6-7.5 9-4.5-1.4-7.5-4.7-7.5-9v-5z" />
            <path d="M8.8 12.2l2.2 2.2 4.2-4.6" />
        </template>
    </svg>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
    name: { type: String, required: true },
    size: { type: Number, default: 21 },
})

const filled = computed(() => props.name === "play" || props.name === "pause")
</script>
